import { render, staticRenderFns } from "./CatalogTabs.vue?vue&type=template&id=16439829&scoped=true"
import script from "./CatalogTabs.vue?vue&type=script&lang=js"
export * from "./CatalogTabs.vue?vue&type=script&lang=js"
import style0 from "./CatalogTabs.vue?vue&type=style&index=0&id=16439829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16439829",
  null
  
)

export default component.exports